import React from 'react'

export default function CommentUserIcon({ comment }) {
  const roleClass = `is-${comment.primary_role}`
  return (
    <>
    {
      // NEXTRIBE: 運営のみリンク化する
      currentUser.operator ? (
        <a
          className="card-list-item__user-icons-icon"
          href={`/users/${comment.user_id}`}>
          <span className={`a-user-role ${roleClass}`}>
            <img className="a-user-icon" src={comment.user_icon} />
          </span>
        </a>
      ) : (
        <div
          className="card-list-item__user-icons-icon">
          <span className={`a-user-role ${roleClass}`}>
            <img className="a-user-icon" src={comment.user_icon} />
          </span>
        </div>
      )
    }
    </>
  )
}
